import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur lång är handläggningstiden för serveringstillstånd?";
const SHORT_ANSWER = "Räkna med 8–12 veckor för stadigvarande tillstånd och 3–6 veckor för tillfälligt, förutsatt att ansökan är komplett.";

export const Route = createFileRoute("/fraga/hur-lang-handlaggningstid")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur lång är handläggningstiden för serveringsti…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Handläggningstiden styrs av kommunens arbetsbelastning och hur snabbt remissinstanser (polis, Skatteverket, räddningstjänst, miljökontor) svarar. Komplett ansökan från start är avgörande. Komplettering i flera omgångar förlänger ofta 4–8 veckor."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/hur-lang-tid-tar-serveringstillstand", label: "Handläggningstid – steg för steg" }}
      related={[{"to": "/fraga/vilka-dokument-kravs", "label": "Vilka dokument krävs i ansökan om serveringstillstånd?"}, {"to": "/fraga/behover-jag-eget-kok-2026", "label": "Behöver jag eget kök 2026 för att få serveringstillstånd?"}, {"to": "/fraga/vad-kostar-ansokan", "label": "Vad kostar en ansökan om serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur lång är handläggningstiden för serveringstillstånd?" },
      { name: "description", content: "Räkna med 8–12 veckor för stadigvarande tillstånd och 3–6 veckor för tillfälligt, förutsatt att ansökan är komplett." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-lang-handlaggningstid" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-lang-handlaggningstid" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-lang-handlaggningstid",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur lång är handläggningstiden för serveringsti…", url: "https://alkoholprovet.se/fraga/hur-lang-handlaggningstid" },
      ]),
    ],
  }),
});
